<template>
    <form @submit.prevent="loginAction">
        <div class="fb-login" v-bind:style="{ display: fbStyle }">
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="form-group">
                        <a class="btn btn-facebook" href="/app/auth/facebook" role="button">
                            <span class="fab fa-facebook-f"></span> {{ $i18n.auth.login_with_facebook }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="row or-login">
                <div class="col-md-12 text-center">
                    {{ $i18n.general.or }}
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-center">
                    <label><a class="text-light show-login-form" @click="showLoginForm">{{ $i18n.auth.login_with_email_password }}</a></label>
                </div>
            </div>
        </div>

        <div class="login-form" v-bind:style="{ display: emailStyle }">
            <div class="form-group">
                <label for="email">{{ $i18n.auth.email_address }}</label>
                <input class="form-control" name="email" type="email" id="email" v-model="user.email">
            </div>

            <div class="form-group">
                <label for="password">{{ $i18n.auth.password }}</label>
                <input class="form-control" name="password" type="password" value="" id="password" v-model="user.password">
            </div>

            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="form-group">
                        <input class="btn btn-login" type="submit" v-bind:value="$i18n.auth.log_in">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="checkbox">
                        <label>
                            <input name="remember" type="checkbox" v-model="user.remember">
                            {{ $i18n.auth.remember_me }}
                        </label>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <div class="forgot-text">
                        <label><router-link class="text-light" :to="{ name: 'recover-password'}">{{ $i18n.auth.forgot_password }}</router-link></label>
                    </div>
                </div>
            </div>

            <div class="row spacer-30">
                <div class="col-md-12 text-center">
                    <label><a class="show-fb-form" @click="showFacebookForm"><i class="fab fa-facebook-square" aria-hidden="true"></i> {{ $i18n.auth.login_with_facebook }}</a></label>
                </div>
            </div>
        </div>
    </form>
</template>

<script type="text/javascript">
export default {
    props: ['loginAction', 'user'],

    data: function() {
        return {
        };
    },

    computed: {
        emailStyle: function() {
            if (this.$route.name == 'login-email') {
                return 'block'
            }

            return 'none';
        },
        fbStyle: function() {
            if (this.$route.name == 'login') {
                return 'block'
            }

            return 'none';
        },
    },

    methods: {
        showFacebookForm: function() {
            $('.login-form').hide();
            $('.fb-login').slideDown(500);
        },
        showLoginForm: function() {
            $('.fb-login').hide();
            $('.login-form').slideDown(500);
            $('#email')[0].focus();
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/login/login-form.vue